import React, { useState } from "react";
import NavLite from "../components/NavLite";
import Footer from "../components/Footer";
import ClaireImage from "../assets/Services/NourivPlatform.png";
import BookingApp from "../assets/Services/Booking App Template.png";
import WaitlistApp from "../assets/Services/Waitlist App Template.png";
import MoneyMind from "../assets/Services/MoneyMind.jpg";
import HeroBg from "../assets/Blackwomen/BWI24.jpg";
import { Helmet } from "react-helmet";

const TemplateShop = () => {
  // Default to the "websites" tab so it's active on load
  const [activeFilter, setActiveFilter] = useState("websites");

  // Put the "Custom Websites" button first in the UI
  const filters = [
    { label: "Custom Websites", value: "websites" },
    { label: "Custom Web Apps", value: "apps" },
  ];

  return (
    <section className="bg-white">
<Helmet>
  <title>Website Templates for Women Entrepreneurs, Coaches & Creatives | Woaom Web Design</title>
  <meta
    name="description"
    content="Shop modern, mobile-optimized website templates for women entrepreneurs, coaches, and creatives. Built with React + Tailwind, Flodesk-ready, and designed for waitlists, booking, and sales funnels in cities like Dallas, Houston, Austin, Atlanta, and New York City."
  />
  <meta
    name="keywords"
    content="website templates for women entrepreneurs, coach website template Dallas TX, Houston booking website kit, Austin TX waitlist funnel template, Atlanta GA course website template, New York City template shop for women entrepreneurs, Washington DC one-page site templates, Philadelphia PA feminine website templates, Memphis TN modern business website kits, Baton Rouge LA creative template store, Shreveport LA React site templates, New Orleans Tailwind CSS website templates, Macon GA Flodesk-ready templates, Augusta GA editable code templates, Baltimore mini Kajabi templates, template shop for women-owned businesses, starter site templates for female founders, Shopify-style templates for women entrepreneurs, course website template Dallas TX, email list website template Houston TX, mobile optimized templates Austin TX, no-code style design templates Atlanta GA, designer templates for women entrepreneurs NYC, client portal template Washington DC, brand-building tools Philadelphia PA, digital tools for coaches Memphis TN, easy to edit sites Baton Rouge LA, business website kits Shreveport LA, digital product templates New Orleans, template packs for women entrepreneurs Macon GA, strategic website templates Augusta GA"
  />
</Helmet>


      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center object-top"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${HeroBg})`,
          width: "100%",
        }}
      >
        {/* Nav stays on top */}
        <div className="relative z-20">
          <NavLite />
        </div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/30 z-10"></div>

        {/* Hero Text */}
        <div className="relative z-10 flex flex-col items-center justify-center md:pt-20 pt-40 pb-28 text-white text-center px-4">
          <h1 className="text-4xl md:text-5xl">The Template Shop</h1>
          <p className="text-lg mt-4 uppercase tracking-widest">
            Templates & Tools for Women Business Owners
          </p>
        </div>
      </div>

      {/* Filter Menu */}
      <div className="max-w-4xl mx-auto px-4 pt-20 text-center">
        <p className="uppercase text-[#C6884A] font-semibold text-sm mb-2 tracking-widest">
          Explore Our Collection
        </p>
        <h2 className="text-4xl text-gray-900 mb-8">
          Custom Websites & Web Apps
        </h2>
        <div className="flex justify-center gap-6 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.value}
              onClick={() => setActiveFilter(filter.value)}
              className={`px-5 py-2 rounded-full font-medium transition-all duration-200 border ${
                activeFilter === filter.value
                  ? "bg-[#C6884A] text-white border-[#C6884A]"
                  : "bg-white text-gray-600 border-gray-300 hover:border-[#C6884A] hover:text-[#C6884A]"
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>

      {/* Filtered Content */}
      <div className="max-w-6xl mx-auto px-4 pb-24">
        {activeFilter === "apps" && (
          <div className="grid md:grid-cols-2 gap-16">
            <div className="text-center">
              <img
                src={ClaireImage}
                alt="client portal template, notion-style client dashboard, CRM for coaches, portal for 1:1 clients, private course dashboard, membership site template, custom dashboard for online business, onboarding portal for clients, student dashboard template, dashboard for course creators"
                className="mx-auto w-full max-w-md mb-6 drop-shadow-lg"
              />
              <h3 className="text-2xl mb-2 text-black">Nouriv Coaching Platform</h3>
              <a
                href="/nouriv"
                className="text-[#C6884A] text-sm uppercase tracking-wide inline-block mt-2"
              >
                View App Template →
              </a>
            </div>
            {/* Add more app templates if needed */}
            <div className="text-center">
              <img
                src={BookingApp}
                alt="e-commerce funnel template, shopify sales funnel, digital product sales page, 
    digital product template, Gumroad product page template, lead magnet funnel for coaches, React product landing page, passive income website template, stripe checkout website, course sales funnel"
                className="mx-auto w-full max-w-md mb-6 drop-shadow-lg"
              />
              <h3 className="text-2xl mb-2 text-black">Booking App Template</h3>
              <a
                href="/bookingapp"
                className="text-[#C6884A] text-sm uppercase tracking-wide inline-block mt-2"
              >
                View App Template →
              </a>
            </div>
            <div className="text-center">
              <img
                src={WaitlistApp}
                alt="web design for women entrepreneurs, feminine website design, launch-ready website, low tech funnel, no code website template, simple website for coaches, website for mindset coach, 
    template for spiritual entrepreneurs, web app for service-based business, women-owned business website"
                className="mx-auto w-full max-w-md mb-6 drop-shadow-lg"
              />
              <h3 className="text-2xl mb-2 text-black">Waitlist App Template</h3>
              <a
                href="/waitlistapp"
                className="text-[#C6884A] text-sm uppercase tracking-wide inline-block mt-2"
              >
                View App Template →
              </a>
            </div>
          </div>
        )}

        {activeFilter === "websites" && (
          <div className="grid md:grid-cols-2 gap-16">
            <div className="text-center">
              <img
                src={MoneyMind}
                alt="website template for coaches, feminine website template, React website template for service providers, sales page template, course website template, booking website template, Kajabi alternative, custom coded website, React Firebase landing page, website template for wellness brand"
                className="mx-auto w-full max-w-md mb-6 drop-shadow-lg"
              />
              <h3 className="text-2xl mb-2 text-black">Money On Mind</h3>
              <a
                href="https://tierag19.sg-host.com/"
                className="text-[#C6884A] text-sm uppercase tracking-wide inline-block mt-2"
              >
                View Website Template →
              </a>
            </div>
            {/* Add more website templates if needed */}
          </div>
        )}
      </div>

      <Footer />
    </section>
  );
};

export default TemplateShop;
